export const scrollIntoView = (id, navigate) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
    });
  } else {
    navigate(`/#${id}`);
  }
};
